import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Horario from '../Horario';

// import { Container } from './styles';
interface IDiasHorarios {
  [key: number]: { dia: string };
}

const DiasHorarios: React.FC = () => {
  const [diasHorarios, setDiasHorarios] = useState<IDiasHorarios>({
    1: { dia: 'Dom' },
    2: { dia: 'Seg' },
    3: { dia: 'Ter' },
    4: { dia: 'Qua' },
    5: { dia: 'Qui' },
    6: { dia: 'Sex' },
    7: { dia: 'Sab' },
  });
  return (
    <>
      <Row noGutters style={{ margin: '24px -11px 10px -11px' }}>
        <Col>
          <div
            style={{
              width: '88px',
              float: 'left',
              backgroundColor: '#c6d7ff',
              padding: '10px 0 10px 4px',
            }}
          >
            <div style={{ marginTop: '30px' }} className="pl-2">
              <b>Inicio</b>
            </div>
            <br />
            <div className="p-2">Intervalo</div>
            <div className="text-right pr-2">Para</div>
            <div className="px-2">Almoço</div>
            <br />
            <div className="px-2">
              <b>Fim</b>
            </div>
            <br />
            <div className="px-2">
              <b>Max. Agendamentos</b>
            </div>
          </div>
        </Col>
        {Object.keys(diasHorarios).map((dia: string) => {
          return (
            <Horario
              dia={diasHorarios[Number(dia)].dia}
              nDia={Number(dia)}
              key={`horario${dia}`}
            />
          );
        })}
      </Row>
    </>
  );
};

export default DiasHorarios;
